// Email signature social links utility function
export const fetchSocialItems = (user) => {
  const SOCIAL_LINKS = [
    {
      id: "call",
      label: "Call",
      number: user?.phone_no,
      imgSrc:
        "https://products.7span.in/assets/da4347f6-71e7-4ea4-8355-a6499fd4b753?cache-buster=2024-11-08T12:13:54.000Z&key=system-large-contain",
    },
    {
      id: "whatsapp",
      label: "WhatsApp",
      number: user?.phone_no,
      imgSrc:
        "https://products.7span.in/assets/22a4a776-007f-4781-a784-594c49ce7acc?cache-buster=2024-11-07T08:10:04.000Z&key=system-large-contain",
    },
    {
      id: "linkedin",
      label: "LinkedIn",
      url: user?.linkedin,
      imgSrc:
        "https://products.7span.in/assets/44f9dc97-d0a7-4fc6-9066-e70cc415f05f?cache-buster=2024-11-07T08:11:11.000Z&key=system-large-contain",
    },
    {
      id: "x",
      label: "X",
      url: user?.x,
      imgSrc:
        "https://products.7span.in/assets/3df9d376-0163-4fa9-a4c2-d1db9f3af248?cache-buster=2024-11-07T08:10:47.000Z&key=system-large-contain",
    },
    {
      id: "website",
      label: "About",
      url: user?.website,
      imgSrc:
        "https://products.7span.in/assets/d8d9e7ad-4a7b-4fba-ba22-fcde536641a9?cache-buster=2024-11-07T08:11:30.000Z&key=system-large-contain",
    },
  ].filter((item) => item.url || item.number); // Only keep links that have URLs
  return SOCIAL_LINKS;
};
